import * as ng from 'angular';

ng.module('e360')
   .directive('copyInput', copyInputDirective);

/**
 * A directive that when added to a button and linked to a text input,
 * copies the text of the input to the clipdboard
 * @usage: Add as an attribute to a button with a value that is the id
 * of the linked input:
 * <button copy-input="id-of-input"... />
 */

copyInputDirective.$inject = ['$window'];
export function copyInputDirective($window: ng.IWindowService):ng.IDirective {
   return {
      restrict: 'A',
      link: link
   };

   function link(scope:ng.IScope, element:ng.IAugmentedJQuery, attr) {
      element.bind('click', copy);

      function copy() {
         let input = ng.element('#' + attr.copyInput).val();

         if (input) {
            //create dummy element to copy from
            var copyElement = $window.document.createElement('span');
            copyElement.appendChild($window.document.createTextNode(input));
            copyElement.id = 'tempId';
            ng.element($window.document.body).append(copyElement);

            //select the text from the dummy element
            var range = $window.document.createRange();
            range.selectNode(copyElement);
            $window.getSelection().removeAllRanges();
            $window.getSelection().addRange(range);
      
            //perform cleanup
            $window.document.execCommand('copy');
            $window.getSelection().removeAllRanges();
            ng.element(copyElement).remove();
         }
      }
   }
}